var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMonthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25016 3.3335C6.36067 3.3335 6.46665 3.37739 6.54479 3.45553C6.62293 3.53368 6.66683 3.63966 6.66683 3.75016V4.16683H13.3335V3.75016C13.3335 3.63966 13.3774 3.53368 13.4555 3.45553C13.5337 3.37739 13.6397 3.3335 13.7502 3.3335C13.8607 3.3335 13.9667 3.37739 14.0448 3.45553C14.1229 3.53368 14.1668 3.63966 14.1668 3.75016V4.16683H15.0002C15.4422 4.16683 15.8661 4.34242 16.1787 4.65498C16.4912 4.96755 16.6668 5.39147 16.6668 5.8335V15.0002C16.6668 15.4422 16.4912 15.8661 16.1787 16.1787C15.8661 16.4912 15.4422 16.6668 15.0002 16.6668H5.00016C4.55814 16.6668 4.13421 16.4912 3.82165 16.1787C3.50909 15.8661 3.3335 15.4422 3.3335 15.0002V5.8335C3.3335 5.39147 3.50909 4.96755 3.82165 4.65498C4.13421 4.34242 4.55814 4.16683 5.00016 4.16683H5.8335V3.75016C5.8335 3.63966 5.87739 3.53368 5.95553 3.45553C6.03368 3.37739 6.13966 3.3335 6.25016 3.3335ZM4.33942 6.66683V14.8276C4.33942 15.0486 4.42722 15.2605 4.5835 15.4168C4.73978 15.5731 4.95174 15.6609 5.17275 15.6609H14.8276C15.0486 15.6609 15.2605 15.5731 15.4168 15.4168C15.5731 15.2605 15.6609 15.0486 15.6609 14.8276V6.66683H4.33942Z",
    fill: "#757575"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.08301,
    y: 8.3335,
    width: 2.5,
    height: 2.5,
    rx: 0.5,
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMonthIcon);
export default __webpack_public_path__ + "static/media/CalendarMonthIcon.fe50d8f8cfb163f30809b29c0b6af86e.svg";
export { ForwardRef as ReactComponent };